import { projectsProjectDetailHostCapability, projectsProjectDetailHostSlots, } from '@crest/module-projects/contracts/detail-host';
import { defineProjectsProjectDetailLauncher } from '@crest/module-projects/contracts/detail-launcher';
import { estimatingModuleManifest } from '../estimating.module.js';
import { estimatingSettingRegistrations } from '../settings/estimating-setting-definitions.js';
export const estimatingWebModuleContribution = {
    moduleId: 'estimating',
    manifest: estimatingModuleManifest,
    settingRegistrations: estimatingSettingRegistrations,
    settingEditors: [],
    hostContracts: [],
    hostContributions: [{
            id: 'estimating.web.projects.estimate-summary',
            moduleId: 'estimating',
            slot: projectsProjectDetailHostSlots.sidebar,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'estimating.estimates.read',
            settingCondition: {
                key: 'estimating.estimates.display',
                property: 'projectPanelEnabled',
                equals: true,
            },
            priority: 45,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            launcher: defineProjectsProjectDetailLauncher({
                fallbackLabel: 'Estimating',
                fallbackDescription: 'Review estimates, proposals, and pricing for this Project.',
                defaultSize: 'wide',
                supportedSizes: ['standard', 'wide', 'large'],
            }),
            load: () => import('./estimating-project-summary.panel.js'),
        }],
    routes: [{
            id: 'estimating.web.estimates',
            moduleId: 'estimating',
            path: '/estimating/estimates',
            requiredPermission: 'estimating.estimates.read',
            navigation: {
                id: 'estimating.navigation.estimates',
                fallbackLabel: 'Estimating',
                labelConfigurationKey: 'estimating.copy.estimates',
                labelValueProperty: 'navigationLabel',
                priority: 55,
            },
            load: () => import('./estimating-estimates.page.js'),
        }, {
            id: 'estimating.web.proposals',
            moduleId: 'estimating',
            path: '/estimating/proposals',
            requiredPermission: 'estimating.estimates.read',
            navigation: {
                id: 'estimating.navigation.proposals',
                fallbackLabel: 'Proposals',
                labelConfigurationKey: 'estimating.copy.proposals',
                labelValueProperty: 'navigationLabel',
                priority: 56,
            },
            load: () => import('./estimating-proposals.page.js'),
        }, {
            id: 'estimating.web.pricebook',
            moduleId: 'estimating',
            path: '/estimating/pricebook',
            requiredPermission: 'estimating.pricebook.read',
            navigation: {
                id: 'estimating.navigation.pricebook',
                fallbackLabel: 'Pricebook',
                labelConfigurationKey: 'estimating.copy.catalog',
                labelValueProperty: 'pricebookNavigationLabel',
                priority: 57,
            },
            load: () => import('./estimating-pricebook.page.js'),
        }, {
            id: 'estimating.web.estimate-templates',
            moduleId: 'estimating',
            path: '/estimating/templates',
            requiredPermission: 'estimating.templates.read',
            navigation: {
                id: 'estimating.navigation.estimate-templates',
                fallbackLabel: 'Estimate templates',
                labelConfigurationKey: 'estimating.copy.catalog',
                labelValueProperty: 'templatesNavigationLabel',
                priority: 58,
            },
            load: () => import('./estimating-estimate-templates.page.js'),
        }, {
            id: 'estimating.web.xactimate',
            moduleId: 'estimating',
            path: '/estimating/xactimate',
            requiredPermission: 'estimating.xactimate.read',
            navigation: {
                id: 'estimating.navigation.xactimate',
                fallbackLabel: 'Xactimate',
                labelConfigurationKey: 'estimating.copy.xactimate',
                labelValueProperty: 'navigationLabel',
                priority: 59,
            },
            load: () => import('./estimating-xactimate.page.js'),
        }],
};
export default estimatingWebModuleContribution;
//# sourceMappingURL=estimating-web.module-contribution.js.map